<template>
 <v-dialog v-model="dialogAdd" persistent max-width="550px" max-height="600px" style="overflow: hidden !important;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">person_add</v-icon>&nbsp;&nbsp;{{$t('LeftSide.addFiend.header')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="height: 400px; overflow: hidden !important; padding: 0;">
      <v-container grid-list-md>
        <v-layout wrap align-center>
          <v-flex sm12 md12 lg12 xl12 style="display: flex;justify-content: center;padding-left: 30px;padding-right: 30px;">
            <v-text-field append-icon="search" solo :label="$t('LeftSide.addFiend.searching')" clearable v-model="search" class="bgsearch" style="color: white !important;" v-on:keyup.enter="searchuser()" @click:append="searchuser()"></v-text-field>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 class="CSChatThai" style="padding-left: 30px;padding-right: 30px;" v-if="statusSearch === ''">
            <v-layout align-center justify-center column>
              <img src="/static/img/onechat/search.jpg" style="width: 170px;">
              <p>{{$t('LeftSide.addFiend.detailSearch')}}</p>
            </v-layout>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 class="CSChatThai" style="padding-left: 30px;padding-right: 30px;" v-else-if="statusSearch === 'not found'">
            <v-layout align-center justify-center column>
              <img src="/static/img/onechat/nosearch.png" style="width: 120px; margin-bottom: 20px;">
              <p align="center" >{{$t('LeftSide.addFiend.nodata', {key: search})}}</p>
            </v-layout>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 v-else style="padding-left: 30px;padding-right: 30px;">
            <v-tabs centered color="cyan" dark icons-and-text>
              <v-tabs-slider color="info"></v-tabs-slider>
                <v-tab href="#tab-2" :key="2" style="color: black !important;" v-if="listuser.length !== 0">
                  User
                    <v-badge right>
        <span slot="badge"> {{listuser.length}} </span>
                  <v-icon style="color: black !important; font-size: 25px !important;">person</v-icon>
                </v-badge>
                </v-tab>
                <v-tab href="#tab-1" :key="1" style="color: black !important;" v-if="listbot.length !== 0">Bot
                  <v-badge right>
        <span slot="badge"> {{listbot.length}} </span>
                   <img src='/static/img/icons/robot.svg' style="width: 25px;" class="alligator-turtle">
                 </v-badge>
                </v-tab>

                <v-tabs-items>
                  <!-- list bot -->
                  <v-tab-item id="tab-1">
                   <v-list two-line style="max-height: 200px;" v-if="listbot.length !== 0" class="scrolling-wrapper">
                    <template v-for="(item, index) in listbot">
                      <v-divider v-if="index != 0"></v-divider>
                      <v-list-tile>
                        <v-list-tile-avatar style="cursor: pointer !important;" @click="openPictureProfile(item.user.profilepicture, item.user.type)">
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                        <v-list-tile-title style="width: 18em;">
                          {{item.user.name}}
                        </v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <!-- {{item}} -->
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item)" class="CSChatThai">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item)" class="CSChatThai">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item,'bot')" class="CSChatThai">{{$t('AnswerQuestion.unblock')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai">{{$t('AnswerQuestion.ok')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'unknown' || item.relation == 'unfriend'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type, item)" class="CSChatThai">{{$t('AnswerQuestion.addFriend')}}</v-btn>
                      </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>

                  <!-- list user -->
                   <v-tab-item id="tab-2">
                    <v-list two-line style="max-height: 200px;" v-if="listuser.length !== 0" class="scrolling-wrapper">
                    <template v-for="(item, index) in listuser">
              <v-divider v-if="index != 0"></v-divider>
                      <v-list-tile>
                        <v-list-tile-avatar style="cursor: pointer !important;" @click="openPictureProfile(item.user.profilepicture, item.user.type)">
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.user.name" style="width: 18em;"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item)" class="CSChatThai">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item)" class="CSChatThai">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item,'user')" class="CSChatThai">{{$t('AnswerQuestion.unblock')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai">{{$t('AnswerQuestion.ok')}}</v-btn>
                        <!-- <v-btn color="blue darken-1" v-else-if="item.relation == 'unknown' || item.relation == 'unfriend'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type, item)" class="CSChatThai">{{$t('AnswerQuestion.addFriend')}}</v-btn> -->
                        <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'true'" flat :loading="loading" @click.native="AddFriendCollab(index, item.user, item.collab_mail)" class="CSChatThai">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false'" flat @click.native="AddFriendCollab(index, item.user, item.collab_mail)" class="CSChatThai">{{$t('AnswerQuestion.addFriend')}}</v-btn>
                        <!-- <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type)" class="CSChatThai">เพิ่มเพื่อน</v-btn> -->
                      </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                      </v-tab-item>
                </v-tabs-items>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>

        <v-dialog v-model="dialogPassword" max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t('LeftSide.addFiend.headerCheckpass')}}
              <v-spacer></v-spacer>
              <v-btn icon @click="close_dialog_pass">
                <v-icon style="color: black !important; font-size: 25px !important;">clear</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-text-field
                @keyup.enter.exact="check_password_bot"
                solo
                :label="$t('LeftSide.addFiend.placeholderPassword')"
                v-model="password"
                clearable
                >
              </v-text-field>
              <!-- <v-text-field
                @keyup.enter.exact="check_password_bot"
                solo
                :label="$t('LeftSide.addFiend.placeholderPassword')"
                v-model="password"
                clearable
                :rules="passwordRules"
                counter
                required
                maxlength="6"
                >
              </v-text-field> -->
              <span style="color: red; padding-left: 10px;">{{message_error}}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="clear_dialog_pass" class="btncancle">
                {{$t('AnswerQuestion.clear')}}
              </v-btn>

              <v-btn @click="check_password_bot" class="btnaddfriend" :loading="loading">
                {{$t('AnswerQuestion.addFriend')}}
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-card-text>
</v-card>
<ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
</v-dialog>
</template>
<script>
// import { mapState } from 'vuex'
// var _ = require('lodash')
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'

export default {
  props: {'dialogAdd': false},
  data: () => ({
    search: '',
    token: '',
    listuser: [],
    listbot: [],
    statusSearch: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: '',
    dialogPassword: false,
    password: '',
    infor_bot: {},
    message_error: '',
    loading: false,
    passwordRules: [
      v => (!!v && v.length >= 6) || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว',
      v => /^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น',
      v => /[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้'
    ]
  }),
  methods: {
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    closeDialog () {
      this.$emit('closeDialogAddFriend', false)
      this.search = ''
      this.statusSearch = ''
      this.listuser = []
      this.listbot = []
      this.message_error = ''
      this.infor_bot = {}
    },
    searchuser () {
      this.listbot = []
      this.listuser = []
      this.axios.post(process.env.APImanage + '/searchusernontype3', {tokenuser: this.token, key: this.search}).then((response) => {
        if (response.data.status === 'success') {
          if (response.data['listuser'].length !== 0 || response.data['listBot'].length !== 0) {
            this.listuser = response.data['listuser']
            this.listbot = response.data['listBot']
            // console.log(this.listbot)
            this.statusSearch = 'found'
          } else {
            this.statusSearch = 'not found'
          }
        }
      })
    },
    AcceptReq (index, item) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: item.user.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.listuser[index].relation = 'friend'
          this.$emit('updatelistreq', {
            event: 'accept',
            tokenuser: item.user.tokenuser,
            name: item.user.name,
            profilepicture: item.user.profilepicture,
            email: item.user.email,
            state: 'friend',
            status: item.user.status,
            type: item.user.type,
            tokenroom: response.data.tokenroom,
            timestamp: response.data.timestamp
          })
        } else {
          console.log('Error')
        }
      })
    },
    RemoveReq (index, item) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: item.user.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.listuser[index].relation = 'unknown'
          this.$emit('updatelistreq', {
            event: 'removeReq',
            tokenuser: item.user.tokenuser
          })
        }
      })
    },
    AddFriend (index, tokenfriend, typeuser, item) {
      // console.log(item)
      if (typeuser === 'user') {
        this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenfriend, tokenuser: this.token}).then((response) => {
          if (response.data.status === 'success') {
            if (typeuser === 'user') {
              this.listuser[index].relation = 'sendrequest'
            }
          }
        })
      } else if (typeuser === 'bot' && item.user.is_password !== '0') {
        this.dialogPassword = true
        this.infor_bot = { 'tokenbot': tokenfriend, 'index': index }
      } else {
        this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenfriend, tokenuser: this.token}).then((response) => {
          if (response.data.status === 'success') {
            this.listbot[index].relation = 'friend'
            this.listbot[index].user.tokenroom = response.data.tokenroom
          }
        })
      }
    },
    AddFriendCollab (index, item, state) {
      // console.log(item)
      // console.log(index)
      this.loading = true
      this.axios.post(process.env.APIgo_api + `/v1/add-friend-accept`, {tokenfriend: item.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.loading = false
          if (state === 'true') {
            this.chat(response.data.tokenroom)
          } else {
            this.listuser[index].relation = 'friend'
            this.listuser[index].user.tokenroom = response.data.tokenroom
          }
        } else {
          this.loading = false
          // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
        }
      }).catch(error => {
        console.log(error)
        this.loading = false
        // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
      })
    },
    check_password_bot () {
      this.message_error = ''
      this.loading = true
      this.axios.post(process.env.APImanage + '/check_password_bot', {tokenBot: this.infor_bot.tokenbot, password: this.password}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            this.axios.post(process.env.APInew_addfriend, {tokenfriend: this.infor_bot.tokenbot, tokenuser: this.token}).then((response) => {
              if (response.data.status === 'success') {
                this.dialogPassword = false
                this.loading = false
                this.password = ''
                this.listbot[this.infor_bot.index].relation = 'friend'
                this.listbot[this.infor_bot.index].user.tokenroom = response.data.tokenroom
              }
            })
          } else {
            this.loading = false
            this.message_error = this.$t('LeftSide.addFiend.messageCheckbot')
            // console.log(response.data.message)
          }
        }
      })
    },
    close_dialog_pass () {
      this.dialogPassword = false
      this.message_error = ''
      this.password = ''
      this.infor_bot = {}
    },
    clear_dialog_pass () {
      // this.dialogPassword = false
      this.message_error = ''
      this.password = ''
      // this.infor_bot = {}
    },
    chat (room) {
      this.closeDialog()
      this.$router.push('/chat/room/' + room)
    },
    unblock (index, item, type) {
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking',{name: item.user.name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: item.user.tokenuser, tokenuser: this.token, tokenroom: item.user.tokenroom }).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                'Unblocked!',
                this.$t('Alert.Success.unblock'),
                'success'
              )
              if (type === 'user') {
                this.listuser[index].relation = 'friend'
              } else if (type === 'bot') {
                this.listbot[index].relation = 'friend'
              }
              // emit ย้อนกลับได้
              var itemfriend = item.user
              itemfriend.event = 'unblock_friend'
              this.$emit('blockevent', itemfriend)
            }
          })
        }
      })
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  watch: {
    search () {
      this.listuser = []
      this.listbot = []
      this.statusSearch = ''
    },
    socketaccept_friend (data) {
      // console.log(data)
      var tokenfriend = data.tokenuser
      // console.log(this.listuser)
      var indexFriend = _.findIndex(this.listuser, function (o) { return o.user.tokenuser === tokenfriend })
      // console.log(indexFriend)
      if (indexFriend != -1) {
        // console.log(this.listuser[indexFriend])
        this.listuser[indexFriend].relation = 'friend'
      }
    //     tokenfriend = data.tokenuser
    //     var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
    //     if (indexSendReq >= 0) {
    //       this.FriendSendReq.splice(indexSendReq, 1)
    //     }
    //   } else {
    //     var indexReq = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenfriend })
    //     if (indexReq >= 0) {
    //       this.FriendReq.splice(indexReq, 1)
    //     }
    //   }
    //   this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: tokenfriend}).then((response) => {
    //     if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
    //       this.listfriend.unshift(response.data.user)
    //       this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
    //     }
    //     // update listchat
    //     var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
    //     var json = response.data.user
    //     json.nickname = ''
    //     json.picture = response.data.user.profilepicture
    //     json.state = 'user'
    //     json.timestamp = data.timestamp
    //     json.count_read = '0'
    //     json.is_active = 'true'
    //     // console.log(json)
    //     if (indexchat >= 0) {
    //       this.listchat.splice(indexchat, 1)
    //       this.listchat.unshift(json)
    //     } else {
    //       this.listchat.unshift(json)
    //     }
    //     // เรียงแชทใหม่ กรณที่มีการ pin
    //     var listpin = []
    //     var linstunpin = []
    //     this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
    //     listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
    //     linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
    //     this.listchat = _.union(listpin, linstunpin)
    //   })
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    ShowImageProfileDialog
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-input .v-label {
  height: 30px !important;
}
>>>.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  padding-left: 22px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
>>>.headline {
  font-size: 18px!important;
  line-height: 32px!important;
}
.btncancle {
  border-style: solid !important;
  background-color: #eee !important;
  border-radius: 7px !important;
  color: #27303e !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
}
.btnaddfriend {
  border-style: solid !important;
  background-color: #1976d2 !important;
  border-radius: 7px !important;
  color: white !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
}
>>> .cyan {
  background-color: white !important;
  border-color: white !important;
}
>>> .v-input__slot {
  border-width: thin !important;
  border-color: #777777d1 !important;
  border-style: solid !important;
  border-radius: 20px !important;
  box-shadow: none !important;
}

.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
 text-transform: none;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 8px;
    height: 0;
}

.expansion_containerAddfriend {
  width: 100%;
  background: #232a35 !important;
  color: white !important;
}

.v-tabs__container--icons-and-text {
    height: 52px;
}

>>>.v-input__control {
    height: 0;
}
/* >>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
} */
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_friend/AddFriendDialog.vue